import { tripColumns } from "../../../Data/Trips/TripHistory";
import React, { Fragment, useState, useEffect, useLayoutEffect, useContext } from "react";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import { Link } from "react-router-dom";
import moment from "moment";
import StatusIcons from "../../../CommonElements/StatusIcons";
import DataTable from "react-data-table-component";
import QuickActions from "./QuickActions";
import EndTripConformation from "./EndTripConformation";
import ActionOptions from "../../Common/Component/ActionOptions";
import { Spinner } from "../../../AbstractElements";
import StartTripConformation from "./StartTripConformation";
import { getUserRole } from "../../../Services/Shared.service";
import { Accountant, OnboardingAgent } from "../../../Data/SideMenu/RouteMapping";
import { Row } from "reactstrap";
import CustomizerContext from "../../../_helper/Customizer";
const TripTable = (props) => {
  const [endTripModal, setEndTripModal] = useState(false)
  const toggleEndTripModal = () => setEndTripModal(!endTripModal)
  const [tripObj, setTripObj] = useState({})
  const [startTripModal, setStartTripModal] = useState(false);
  const toggleStartTripModal = () =>
    setStartTripModal(!startTripModal);
  const userRole = getUserRole()
  const { mix_background_layout } = useContext(CustomizerContext);

  const processData = props.tripData.map((element, index) => {
    return {
      tripObject: element ? element : {},
      booking_number: (
        <Link
          to={`${process.env.PUBLIC_URL}/trips/trip-info/${element.id}`}
          onClick={() => props.setPageNumber(props.pagination)}
          state={{ previousUrl: window.location.pathname, filterdata: props.filterData, searchdata: props.searchData }}
        >
          {element.megaCabsBookingNo}
        </Link>
      ),
      pickup_time: element.pickUpDateTime
        ? moment(new Date(element.pickUpDateTime)).format("MMM DD HH:mm")
        : "-",
      customer_name: element.custName ? element.custName : "-",
      phone_number: (
        <Link
          to={`${process.env.PUBLIC_URL}/customers/customer-profile/${element.customerId}`}
          onClick={() => props.setPageNumber(props.pagination)}
          state={{ previousUrl: window.location.pathname, filterdata: props.filterData, searchdata: props.searchData }}
        >
          {element.custMobile}
        </Link>
      ),
      pickup_location: element.pickUpAddress ? (
        element.pickUpAddress
      ) : (
        "-"
      ),
      drop_location: element.destAddress ? (
        <>
          <span id={"dropLocation" + index}>
            {element.destAddress.includes("Kempegowda")
              ? "Kempegowda Airport"
              : element.destAddress}
          </span>
          <CommonToolTip
            options={{
              placement: "left",
              target: "dropLocation" + index,
            }}
          >
            {element.destAddress}
          </CommonToolTip>
        </>
      ) : (
        "-"
      ),
      status: element.currentTripStatusType ? (
        <>
          <span className="status-icon">
            <span id={"statusIcons" + index}>
              <StatusIcons statusType={element.currentTripStatusType} />
            </span>
            <CommonToolTip
              options={{
                placement: "left",
                target: "statusIcons" + index,
              }}
            >
              {element.currentTripStatusType}
            </CommonToolTip>
          </span>
        </>
      ) : (
        "-"
      ),
      booking_via: element.bookingViaType ? element.bookingViaType : "-",
      driver_assigned: element.driverName ? element.driverName : '-',
      cab_number: element.carNo ? element.carNo : '-',
      car_Type: element.carType ? element.carType : '-',
      action: (
        <ActionOptions key={index}>
          <QuickActions
            toggleEndTripModal={() => {
              setTripObj(element)
              toggleEndTripModal()
            }}
            element={element}
            toggleStartTripModal={() => {
              setTripObj(element)
              toggleStartTripModal()
            }}
          />
        </ActionOptions>
      ),
    };
  });

  const [fixedHeaderScrollHeight, setfixedHeaderScrollHeight] = useState(() => {
    return "57vh";
  });

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 575.98) {
        setfixedHeaderScrollHeight(51 + "vh");
      } else {
        setfixedHeaderScrollHeight(() => {
          return 57 + "vh";
        });
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const ExpandedComponent = ({ data }) => {
    // return <pre>{JSON.stringify(data.bookingObject, null, 2)}</pre>
    return <Row style={{ padding: "20px 0px", margin: "0px" }}>
      <div className="col-lg-3">
        <span style={{ fontWeight: "bold" }}>Driver Assigned By : </span>{data.tripObject.driverAssignedByUserType ? data.tripObject.driverAssignedByUserType : "-"}
      </div>
      <div className="col-lg-3">
        <span style={{ fontWeight: "bold" }}>Cab Type : </span>{data.tripObject.carType ? data.tripObject.carType : "-"}
      </div>
      <div className="col-lg-3">
        <span style={{ fontWeight: "bold" }}>Driver Number : </span>{data.tripObject.driverMobileNo ? data.tripObject.driverMobileNo : "-"}
      </div>
    </Row>
  }

  return (
    <div >
      <div className="table-responsive trip-table">
        <DataTable
          columns={userRole.some((element) => element != Accountant || element != OnboardingAgent) ? tripColumns : tripColumns.slice(0, tripColumns.length - 1)}
          data={processData}
          center={true}
          fixedHeader
          fixedHeaderScrollHeight={fixedHeaderScrollHeight}
          pagination
          paginationPerPage={props.paginationPerPage}
          paginationDefaultPage={props.pageNumber}
          paginationTotalRows={props.paginationTotalRows}
          paginationRowsPerPageOptions={[10,20,30,100,150]}
          onChangePage={props.onChangePage}
          onChangeRowsPerPage={props.onChangeRowsPerPage}
          paginationServer
          // customStyles={customStyles}
          progressPending={props.loader}
          progressComponent={<div className="loader-box" style={{ height: fixedHeaderScrollHeight }}>
            <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
          </div>}
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
        <EndTripConformation
          LargeModaltoggle={()=>{
            props.fetchTripData()
            toggleEndTripModal()
          }}
          title={"End Trip"}
          Large={endTripModal}
          tripObj={tripObj}
        />
        <StartTripConformation
          LargeModaltoggle={()=>{
            props.fetchTripData()
            toggleStartTripModal()
          }}
          title={"Start Trip"}
          Large={startTripModal}
          tripObj={tripObj}
        />
      </div>
    </div>
  );
};
export default TripTable;
